export const DATALINE_DEFINITION_MAX_LENGTH = 512;
export const DATALINE_DEFINITION_MAX_NUMBER = 50;
export const DATALINE_RESPONSE_DRIVER_MINIMUM = 30;
export const SHAPING_NAME_MAX_LENGTH = 25;

export const DATALINE_ERRORS = {
  UNNAMED: 'UNNAMED_DATALINE',
  NAME_TOO_LONG: 'DATALINE_NAME_TOO_LONG',
  EMPTY_DEFINITIONLINE: 'EMPTY_DEFINITIONLINE',
  MISSING_ORG_UNIT: 'MISSING_ORG_UNIT',
  TOO_MANY_DEFINITIONLINES: 'TOO_MANY_DEFINITIONLINES',
};
Object.freeze(DATALINE_ERRORS);

export enum LogicalOperator {
  AND = 'isin',
  EXCLUDE = 'notin',
  OR = 'or',
}

export enum DatalineType {
  NODE = 1,
  SPLIT = 2,
  FILTER = 3,
  EXTERNAL = 4,
}

export enum DatalineProdStatus {
  ORDERED = 0,
  READY = 2,
}

export enum DatalineStatus {
  STATUS_OK = 0,
  STATUS_TOO_FEW_NUMBER_OF_CASES = 1,
  STATUS_AVOID_NEGATIVE_SELECTION = 2,
  STATUS_PENDING = 99,
  STATUS_LOADING = 200,
  STATUS_ERROR = 201,
}
